

























import { Component, Vue } from 'vue-property-decorator';

import { getDefaultRoleListApi, getMenuListByRoleIdApi, setMenuByRoleIdApi } from '@/api/company';
import { debounce } from '@/utils/function_utils';

@Component({
  name: 'authorityList',
})
export default class extends Vue {
  public activeName: string = '';
  public roleKey: number | string = '';
  public tabsData: any = [];
  public menuList: any = [];
  public fkResourceKeys: string[] = [];
  public isLoading: boolean = false;

  // 利用防抖避免连续多次点击发送多次请求
  public getTables = debounce(this.getTableDatas, 500);

  public async getTableDatas() {
    const { data } = await getDefaultRoleListApi();
    this.initActiveName(data.datas);
    this.tabsData = data.datas;
  }

  public initActiveName(datas: any) {
    if (datas.length && !this.tabsData.length) {
      this.activeName = '0';
      const key = datas[0].typeKey;
      this.roleKey = key;
      this.getMenuListByRoleId(key);
    }
  }

  public handleCheckbox(itemKey: string, parentItem: any) {
    const keys = this.fkResourceKeys;
    if (keys.some((key) => key === itemKey) && !keys.some((key) => key === parentItem.resourceKey)) {
      keys.push(parentItem.resourceKey);
    }
  }

  public handleTabClick(tab: any) {
    const index = Number(tab.name);
    const item = this.tabsData[index];
    this.roleKey = item.typeKey;
    this.getMenuListByRoleId(item.typeKey);
  }

  public async getMenuListByRoleId(key: string) {
    const { data } = await getMenuListByRoleIdApi(key);
    this.menuList = data.datas;
    this.fkResourceKeys = [];
    this.menuList.forEach((item: any) => {
      if (item.isChecked) {
        this.fkResourceKeys.push(item.resourceKey);
      }
      item.resourceDtoList.forEach((resource: any) => {
        if (resource.isChecked) {
          this.fkResourceKeys.push(resource.resourceKey);
        }
      });
    });
  }

  public async setMenu() {
    this.isLoading = true;
    try {
      await setMenuByRoleIdApi({
        fkContactPersonTypeKey: this.roleKey,
        fkResourceKeys: this.fkResourceKeys,
      });
      this.$message.success(this.$t('message.saveSuccessMsg') as string);
    } finally {
      this.isLoading = false;
    }
  }
}
